import { useNavigate } from 'react-router-dom';
import TopBar from '../components/molecules/TopBar';
import TopBarBackButton from '../components/atoms/TopBarBackButton';
import { useAppSelector } from 'src/store/hooks';
import MarkdownRenderer from 'src/components/molecules/MarkdownRenderer';

const PrivacyInformation = () => {
    const navigate = useNavigate();
    const config = useAppSelector(state => state.globalState.config);

    return (
        <div className="content">
            <TopBar
                title="Datenschutz"
                icon={'icon_question_mark.svg'}
                leftButtons={[<TopBarBackButton onClick={() => navigate('../settings')} />]}
            />
            <div className="content-container legal-info">
                <h2>Datenschutz</h2>
                <div>
                    {config?.privacyContent && (
                        <MarkdownRenderer content={config.privacyContent} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default PrivacyInformation;